import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const H3B = styled.h3`
  font-weight: 600;
  font-size: 24px;
  line-height: 37px;
  ${customTextColor}
`;
